import { useTranslation } from 'react-i18next';
import { useNotifications } from 'pos-client/hooks/useNotifications.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';

export const useCreateBlockedSlot = (handleClose: () => void) => {
  const trpcContext = trpc.useUtils();

  const { t } = useTranslation();

  const { showSuccess, showError } = useNotifications();

  const { mutate: createBlockedSlot, isLoading: createBlockedSlotIsLoading } =
    trpc.createBlockedSlot.useMutation({
      onSuccess: () => {
        trpcContext.findScheduleBoardJobsAndBlockedSlots.invalidate();

        showSuccess(
          t('common.notification.success.message', {
            action: 'created',
            entity: 'blocked slot',
          })
        );

        return handleClose && handleClose();
      },
      onError: () => {
        showError(
          t('common.notification.error.message', {
            action: 'create',
            entity: 'blocked slot',
          })
        );
        handleClose();
      },
    });

  return { createBlockedSlot, createBlockedSlotIsLoading };
};
